module.exports = __webpack_public_path__ + "img/MDS.90f68a69.png";